import { Accordion, AccordionTab } from "primereact/accordion";
import { Tag } from "primereact/tag";
import Loading from "../common/Loading";
import NoContent from "../common/NoContent";
import { toAppDate } from "../../utils";
import { TEXT_NORMAL, TEXT_SMALL } from "../../style";

function qualitySeverity(quality) {
    if (quality === "auspicious") return "success";
    if (quality === "inauspicious") return "danger";
    return "info";
}

function formatSlotTime(value) {
    const date = toAppDate(value);
    if (!date) return "--";
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

function SlotList({ title, slots }) {
    if (!slots?.length) {
        return <div className={`${TEXT_SMALL} text-color-secondary`}>{title}: no slots</div>;
    }

    return (
        <div className="flex flex-column gap-2">
            <div className={`${TEXT_SMALL} font-semibold text-color-secondary`}>{title}</div>
            {slots.map((slot) => (
                <div
                    key={`${slot.period}-${slot.slot}`}
                    className="flex align-items-center justify-content-between gap-2 border-1 border-gray-200 border-round px-2 py-1"
                >
                    <div className="flex align-items-center gap-2 min-w-0">
                        <Tag value={slot.name} severity={qualitySeverity(slot.quality)} pt={{ value: { className: TEXT_SMALL } }} />
                        <span className={`${TEXT_SMALL} text-color-secondary`}>#{slot.slot}</span>
                    </div>
                    <span className={`${TEXT_NORMAL} white-space-nowrap`}>
                        {formatSlotTime(slot.start_at)} - {formatSlotTime(slot.end_at)}
                    </span>
                </div>
            ))}
        </div>
    );
}

export default function ChoghadiyaPanel({ loading, error, data }) {
    const daySlots = data?.day || [];
    const nightSlots = data?.night || [];
    const hasSlots = daySlots.length > 0 || nightSlots.length > 0;

    return (
        <div className="px-3 pb-2">
            <Accordion>
                <AccordionTab
                    header={
                        <div className="flex align-items-center justify-content-between gap-2 w-full pr-2">
                            <span className={`${TEXT_NORMAL} font-semibold`}>Choghadiya</span>
                        </div>
                    }
                >
                    {loading ? (
                        <Loading message="Loading choghadiya" />
                    ) : error ? (
                        <NoContent error={error} />
                    ) : hasSlots ? (
                        <div className="flex flex-column gap-3">
                            <SlotList title="Day" slots={daySlots} />
                            <SlotList title="Night" slots={nightSlots} />
                        </div>
                    ) : (
                        <NoContent error="Choghadiya not available for this date yet" />
                    )}
                </AccordionTab>
            </Accordion>
        </div>
    );
}
